export class Response<T> {
    code: number;
    message: string;
    data: T;

    isSuccessful(): boolean {
        return this.code === 200;
    }

    isFailed(): boolean {
        return !this.isSuccessful();
    }
}